import React from 'react';
import {
  PopupSt,
  PopupWrapSt,
  PopupCloseSt,
} from './style.js';

const PopupNew = ({ children, handleOpenPopupClick }) => (
  <PopupSt>
    <PopupWrapSt>
      <PopupCloseSt onClick={(e) => handleOpenPopupClick(e)} />
      {children}
    </PopupWrapSt>
  </PopupSt>
);

export default PopupNew;
